/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const NO_DIFF_MESSAGE = 'Compared values have no visual difference.';

export const SIMILAR_MESSAGE =
    'Compared values serialize to the same structure.\n' +
    'Printing internal object structure without calling `toJSON` instead.';
